export default "__VITE_ASSET__ccGbC4Ta__"